import React from "react";
import {useVehicleInspectionData} from "../../hooks/useVehicleInspectionData";
import {useSelector} from "react-redux";
import {getInspectionData} from "../../state/selectors";
import {Table} from "react-bulma-components";
import VehicleInspectionRow from "./VehicleInspectionRow";

export default function Inspections({vehicle, onInspectionAdd, attached_inspections, type}) {
  let complete = useVehicleInspectionData(vehicle.id)
  let data = useSelector(getInspectionData);

  if (complete) {
    return (
      <Table bordered>
        <thead>
        <tr>
          <th className={"table-header-bold"}>Inspection Type</th>
          <th className={"table-header-bold"}>Inspection Workshop</th>
          <th className={"table-header-bold"}>Expiry Date</th>
          <th className={"table-header-bold"}></th>
        </tr>
        </thead>
        <tbody>
        {data.results.map(inspection => (<VehicleInspectionRow
            inspection={inspection}
            onInspectionAdd={onInspectionAdd}
            attached_inspections={attached_inspections}
            type={type}
          />))}
        </tbody>
      </Table>)
  } else {
    return (<Table bordered>
        <thead>
        <tr>
          <td>Inspection Type</td>
          <td>Inspection Workshop</td>
          <td>Expiry Date</td>
          <th></th>
        </tr>
        </thead>
      </Table>)
  }

}